import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileTypeService } from '../../services/fileType.service';
import { map, startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../services/notification.service';
import { PIDService } from '../../services/pid.service';
import { FileService } from '../../services/file.service';
import { ContractorService } from '../../services/contractor.service';
import { UserService } from '../../services/user.service';
import { MatAccordion } from '@angular/material/expansion';
import { DatePipe } from '@angular/common';
import { combineLatest } from 'rxjs';
import { FormControl, FormArray, FormGroup, FormBuilder } from "@angular/forms";

export interface DialogData {
    pid: string,
    selection: string[];
    files: object[];
}

@Component({
    selector: 'massedit-dialog',
    templateUrl: './massedit.component.html',
    styleUrls: ['./massedit.component.scss']
})
export class MassEditDialog implements OnInit {

    fileTypes;
    filteredFileTypes;
    fileTypeControl: FormControl = new FormControl();
    contractorControl: FormControl = new FormControl();
    newFile = {
        type: '', contractor: '', emailSent: false, providedByContractor: true,
        completion: '', removeNotifications: false, removeSharedWith: false
    };
    allRooms = [];
    allContractors = [];
    filteredContractors;
    notifications = [];
    sharedWith = [];
    notrowspan = 1;
    frequencies = [];
    shareFilteredContractors = [];

    deleteSelected = false;
    pInfoDisabled = false;
    pNotDisabled = false;
    pShareDisabled = false;
    toRemoveContractor = false;


    form: FormGroup;

    @ViewChild(MatAccordion) accordion: MatAccordion;

    constructor(
        public dialogRef: MatDialogRef<MassEditDialog>,
        public translate: TranslateService,
        private _user: UserService,
        public fileTypeService: FileTypeService,
        private _fileService: FileService,
        private _pidService: PIDService,
        private _contractorService: ContractorService,
        private datePipe: DatePipe,
        private _notification: NotificationService,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            items: this.formBuilder.array([])
        });
        //  Setup fileType filtered list
        this.loadFileTypes();
        this.loadFrequencyTypes();
        this.addSharedWith();
        //console.log("mass edit notificatons", this.notifications);

        this._contractorService.getMine()
            .subscribe(
                (contractors: any) => {
                    //console.log("all contractors", contractors, contractors.length);
                    // .filter(x => !x.shared)
                    contractors = contractors.filter(x => !x.hidden).sort(function (a, b) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                        if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                        return 0;
                    });
                    this.allContractors = contractors;
                    this.filteredContractors = this.contractorControl.valueChanges.pipe(
                        startWith(null),
                        map((val: string) => val && val.length >= 1 ? this.contractorAutocompleteFilter(this.allContractors, val) : this.allContractors.slice(0, 0)));

                    //console.log("all contractors", contractors, contractors.length, this.filteredContractors, this.filteredContractors.length);
                });
        //});
    }

    formatContractor(c) {
        return c.name + ' (' + c.email + ')';
    }

    get items(): FormArray {
        return this.form.get('items') as FormArray;
    }

    contractorAutocompleteFilter(list, val: string) {
        //console.log("contractor acw", list, val);
        return list.filter(option => ((option.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (option.email.toLowerCase().indexOf(val.toLowerCase()) > -1)));
    }

    autocompleteFilter(list, val: string) {
        return list.filter(option => option.value.toLowerCase().indexOf(val.toLowerCase()) > -1);
    }

    loadFileTypes(): void {

        this.fileTypeService.getMe()
            .subscribe(result => {
                this.fileTypes = result;
                //noinspection TypeScriptValidateTypes
                this.filteredFileTypes = this.fileTypeControl.valueChanges.pipe(
                    startWith(null),
                    map(val => val && val.length >= 2 ? this.autocompleteFilter(this.fileTypes, val) : this.fileTypes.slice(0, 0)));
            });
    }

    addNotification() {
        var not = { topic: '', targetdate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'), frequency: 'YEARLY' };
        //this.notrowspan += 3;
        this.notifications.push(not);
    }

    addSharedWith() {

        var index = this.sharedWith.length

        this.items.push(this.formBuilder.group({
            sharedWithEmail: ["", []],
        }));
        this.shareFilteredContractors[index] = this.items.at(index).get('sharedWithEmail').valueChanges.pipe(
            startWith(null),
            map((val: string) => val && val.length >= 1 ? this.contractorAutocompleteFilter(this.allContractors, val) : this.allContractors.slice(0, 0)));
        this.sharedWith.push({ email: '' });
    }

    loadFrequencyTypes(): void {
        this.frequencies = ['REPEAT_NOT', '5 YEARLY', '2 YEARLY', 'YEARLY', '6MONTHLY', '3MONTHLY', 'MONTHLY', 'WEEKLY', 'DAYLY'];
    }

    contractorId(contractor) {
        let c = this.allContractors.find(c => {
            return (this.formatContractor(c) == contractor);
        });

        return c && c._id || null;
    }


    contractorEmail(contractor) {
        //console.log("contractor email", contractor);
        let c = this.allContractors.find(c => {
            return (this.formatContractor(c) == contractor);
        });
        //console.log("contractor email", c && c.email || c);
        return c && c.email || null;
    }

    removeAllNotifications() {
        this.notifications = [];
    }

    contractorRO() {
        return this.toRemoveContractor === true;
    }

    removeContractor() {
        if (!this.toRemoveContractor) {
            this.newFile.contractor = '-1';
        } else {
            this.newFile.contractor = '';
        }
    }

    removeAllSharedWith() {
        this.sharedWith = [];
    }

    deleteSelectedClick() {
        let oldval = this.deleteSelected;
        this.pInfoDisabled = !oldval;
        this.pNotDisabled = !oldval;
        this.pShareDisabled = !oldval;
    }

    deleteSelectedFiles() {
        let proms = [];
        this.data.selection.forEach((x) => {
            //console.log("delete file from selecteion", this.data.selection, x);
            proms.push(this._fileService.deleteFile(this.data.pid, x));
        });

        return combineLatest(proms).subscribe(ret => {
            //console.log("files deleted", ret);
            this.dialogRef.close(true);
        });
    }

    save() {

        if (this.deleteSelected) {
            return this.deleteSelectedFiles();
        }

        if (this.newFile.contractor && !this.toRemoveContractor && !this.contractorId(this.newFile.contractor)) {
            //this.newFile.contractor = '';
            this._notification.warning('MASSEDIT.NOT_SAVED','MASSEDIT.CONTRACTOR_NOT_FOUND');
            return;
        }

        let proms = [];

        let data = {};
        if (this.newFile.type) {
            data['type'] = this.newFile.type;
        }
        if (this.toRemoveContractor){
            data['contractor'] = -1;
            data['providedByContractor'] = true;
        }
        else if (this.newFile.contractor) {
            data['contractor'] = this.contractorId(this.newFile.contractor);
            data['providedByContractor'] = true;
        }
        
        if (this.newFile.completion) {
            data['deadline'] = this.newFile.completion;
        }

        if (this.notifications.length) {
            data['notifications'] = this.notifications.filter(r => r.topic.length > 0);
        }

        if (this.newFile.removeNotifications) {
            data['notifications'] = [];
        }

        if (this.newFile.removeSharedWith) {
            data['sharedWith'] = [];
        }

        var filesPerId = this.data.files.reduce(function (map, obj) {
            map[obj['_id']] = obj;
            return map;
        }, {});

        var sentPerContractor = {};
        if (Object.keys(data).length) {
            this.data.selection.forEach((x, i) => {
                if (this.newFile.contractor && this.newFile.contractor.trim().length > 0) {
                    proms.push(this._fileService.update(this.data.pid, x, data, i == 0 ? 1 : 0));
                } else {
                    let contractor = filesPerId[x].contractor;
                    let sent = contractor && !sentPerContractor.hasOwnProperty(contractor._id) || false;
                    proms.push(this._fileService.update(this.data.pid, x, data, sent ? 1 : 0));
                    if (contractor) sentPerContractor[contractor._id] = true;
                }
            });
        }

        var sharedWith = this.sharedWith.map((v, i) => this.items.at(i).get('sharedWithEmail').value).filter(r => r && r.length > 0);
        //console.log("link stats", sharedWith.length, sharedWith, this.newFile.removeSharedWith);
        if (sharedWith.length || this.newFile.removeSharedWith) {

            let flproms = [];
            let linksperfile = {};
            this.data.selection.forEach((x) => {
                flproms.push(this._fileService.getFileLinkStats(x))
            });
            combineLatest(flproms).subscribe((ret: any[]) => {
                ret.forEach((stat: any, i) => {
                    linksperfile[this.data.selection[i]] = [];
                    stat.all.forEach((x: any) => {
                        linksperfile[this.data.selection[i]].push(x.email);
                    })
                })
                this.data.selection.forEach((x, selection_i) => {
                    sharedWith.forEach(s => {
                        if (!linksperfile[x].includes(s)) {
                            proms.push(this._fileService.initLink(this.data.pid, x, this.contractorEmail(s)));
                        }
                    })
                    linksperfile[x].forEach((s, j) => {
                        if (!sharedWith.includes(s)) {
                            let linkId = ret[selection_i].all[j]._id;
                            proms.push(this._fileService.unlink(linkId));
                        }
                    })
                });
                combineLatest(proms).subscribe((ret: any[]) => {
                    this.userFeedback(ret);
                    this.dialogRef.close(true);
                });
            });
        } else {
            return combineLatest(proms).subscribe(ret => {
                this.userFeedback(ret);
                this.dialogRef.close(true);
            });
        }
        this.dialogRef.close(true);
    }

    userFeedback(ret: any[]) {
        //console.log("user feedback", ret, ret.map(x => x.emailSent), ret.map(x => x.emailSent).filter(x => x).length, ret.map(x => x.emailSent).filter(x => x), ret.map(x => x.emailSent), ret);

        let mailssent = ret.map(x => x.emailSent).filter(x => x).length;

        if (mailssent) {
            this._notification.info('MESSAGE.MAILS_SENT_JOBS_SAVED');
        } else {
            this._notification.info('MESSAGE.JOBS_SAVED');
        }
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

}